var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDF2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.96 15.164C17.0103 14.1131 17.6003 12.6882 17.6003 11.2024C17.6003 9.71663 17.0103 8.29167 15.96 7.2408C15.4401 6.72054 14.8228 6.30783 14.1433 6.02625C13.4638 5.74466 12.7355 5.59973 12 5.59973C11.2645 5.59973 10.5362 5.74466 9.8567 6.02625C9.17723 6.30783 8.5599 6.72054 8.03999 7.2408C6.98966 8.29167 6.39964 9.71663 6.39964 11.2024C6.39964 12.6882 6.98966 14.1131 8.03999 15.164L9.25679 16.3632L10.8912 17.9512L10.9976 18.0456C11.6176 18.548 12.5256 18.516 13.1096 17.9512L15.0576 16.0552L15.96 15.164V15.164ZM12 13.6C11.3635 13.6 10.753 13.3471 10.3029 12.8971C9.85285 12.447 9.59999 11.8365 9.59999 11.2C9.59999 10.5635 9.85285 9.95303 10.3029 9.50294C10.753 9.05286 11.3635 8.8 12 8.8C12.6365 8.8 13.247 9.05286 13.697 9.50294C14.1471 9.95303 14.4 10.5635 14.4 11.2C14.4 11.8365 14.1471 12.447 13.697 12.8971C13.247 13.3471 12.6365 13.6 12 13.6Z",
    fill: "#227EFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.2495a93ad69d9cc9ad91c5ac0614debb.svg";
export { ForwardRef as ReactComponent };